<template lang='pug' src='./new-patients.pug'></template>

<script>
import Loader from 'components/loader/loader'
import ModalContact from 'components/modal/modal-contact/modal-contact'
import CustomNewPatientsFirstVisit from 'components/custom/custom-new-patients-first-visit/custom-new-patients-first-visit'
import CustomNewPatientsConsultation from 'components/custom/custom-new-patients-consultation/custom-new-patients-consultation'
import CustomNewPatientsTabs from 'components/custom/custom-new-patients-tabs/custom-new-patients-tabs'
import DividerText from 'components/divider/divider-text/divider-text'
import BlockParagraph from 'components/block/block-paragraph/block-paragraph'
import DividerLogos from 'components/divider/divider-logos/divider-logos'
import Modal from 'components/modal/modal'

export default {
  name: 'new-patients',
  computed: {
    props () {
      return this.$store.state.pages['new-patients']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  created () {
    this.$store.dispatch('VIEW_NAV', true)
  },
  components: {
    Loader,
    ModalContact,
    CustomNewPatientsFirstVisit,
    CustomNewPatientsConsultation,
    CustomNewPatientsTabs,
    DividerText,
    BlockParagraph,
    DividerLogos,
    Modal
  }
}
</script>



// WEBPACK FOOTER //
// new-patients.vue?26b2dc23